import { useEffect } from 'react';
const dispatchChangeLocale = (lng) => window.dispatchEvent(new CustomEvent('change-locale', {
    detail: lng === 'ca' ? 'es' : lng,
}));
const useLocale = (lng) => {
    useEffect(() => {
        dispatchChangeLocale(lng);
    }, [lng]);
};
export default useLocale;
